export const ALL_TABS_EMPTY_KEY = "ALL_TABS_EMPTY"


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/constants.js